import React, { useState, useEffect, useCallback,useRef } from 'react';
import { useLocation, Link } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import './BigData.css';
// import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
import { Bar, Line, Pie, Scatter, Chart } from 'react-chartjs-2';
import 'chart.js/auto';

const fallbackData = [
  { dateRead: '01-01-2024', pageCount: 10, timeSpent: '30:00' },
  { dateRead: '02-01-2024', pageCount: 20, timeSpent: '45:00' },
  { dateRead: '03-01-2024', pageCount: 15, timeSpent: '20:00' },
];

const ReadLogBarChart = ({ data, title }) => {
  // console.log("Inside barchart: ", data, title);

  if (!data || data.length === 0) {
    return <div className='flex flex-row justify-center text-xl text-white'>No data available</div>;
  }

  // Ensure date format is correct and sort in ascending order
  const sortedData = [...data].sort((a, b) => {
    const parseDate = (dateStr) => {
      const [day, month, year] = dateStr.split("-").map(Number);
      return new Date(year, month - 1, day);
    };
  
    return parseDate(a.dateRead) - parseDate(b.dateRead);
  });

  // console.log("Sorted Data: ", sortedData);

  const chartData = {
    labels: sortedData.map(entry => entry.dateRead),
    datasets: [
      {
        label: 'Time Spent (seconds)',
        data: sortedData.map(entry => {
          const timeParts = entry.timeSpent.split(':').map(Number);
          return timeParts[0] * 60 + timeParts[1];
        }),
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      }
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: 'white',
        },
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems) => tooltipItems[0]?.label ?? '',
          label: (tooltipItem) => `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
        },
        titleColor: 'white',
        bodyColor: 'white',
      },
    },
    scales: {
      x: {
        ticks: {
          color: 'white',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
      },
      y: {
        ticks: {
          color: 'white',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

const transformGraphDataForLineChart = (graphData) => {
  const result = [];
  const dateCounts = {};

  // Count records per date
  Object.keys(graphData).forEach(date => {
    dateCounts[date] = graphData[date].length;
  });

  // Convert dateCounts object to an array of objects with date and count
  Object.keys(dateCounts).forEach(date => {
    result.push({
      dateRead: date,
      count: dateCounts[date],
    });
  });

  // Sort by date in descending order
  result.sort((a, b) => new Date(b.dateRead) - new Date(a.dateRead));

  return result;
};


const ReadLogLineChart = ({ data }) => {
  // Prepare data for the chart

    // Ensure date format is correct and sort in ascending order
    const sortedData = [...data].sort((a, b) => {
      const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day);
      };
    
      return parseDate(a.dateRead) - parseDate(b.dateRead);
    });

  const chartData = {
    labels: sortedData.map(entry => entry.dateRead),
    datasets: [
      {
        label: 'Records Count',
        data: sortedData.map(entry => entry.count),
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 2,
        fill: false,
      },
    ],
  };

  // Determine the min and max counts for y-axis interval
  const counts = data.map(entry => entry.count);
  const minCount = Math.min(...counts);
  const maxCount = Math.max(...counts);
  const yAxisStepSize = Math.ceil((maxCount - minCount) / 20);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: 'white',
        },
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems) => tooltipItems[0]?.label ?? '',
          label: (tooltipItem) => `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
        },
        titleColor: 'white',
        bodyColor: 'white',
      },
    },
    scales: {
      x: {
        ticks: {
          color: 'white',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
      },
      y: {
        ticks: {
          color: 'white',
          stepSize: yAxisStepSize, // Set y-axis interval
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};



// Pie Chart Component
const ReadLogPieChart = ({ data }) => {

    // Ensure date format is correct and sort in ascending order
    const sortedData = [...data].sort((a, b) => {
      const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day);
      };
    
      return parseDate(a.dateRead) - parseDate(b.dateRead);
    }); 

  const chartData = {
    labels: sortedData.map(entry => entry.dateRead),
    datasets: [
      {
        label: 'Time Spent',
        data: sortedData.map(entry => parseInt(entry.timeSpent.split(':').reduce((acc, time) => (60 * acc) + +time))),
        backgroundColor: [
          'rgba(255, 99, 132, 0.6)',
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 206, 86, 0.6)',
          'rgba(75, 192, 192, 0.6)',
          'rgba(153, 102, 255, 0.6)',
        ],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: 'white',
        },
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems) => tooltipItems[0]?.label ?? '',
          label: (tooltipItem) => `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
        },
        titleColor: 'white',
        bodyColor: 'white',
      },
    },
  };

  return <Pie data={chartData} options={options} />;
};


const groupByTimeSlotAndInterval = (graphData) => {
  const timeSlots = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22]; // 2-hour slots
  const result = [];

  // Initialize result array with all time slots
  timeSlots.forEach(slot => {
    result.push({
      x: slot, // X-Axis (Time Slot)
      y: 0, // Y-Axis (Hour count)
      count: 0, // Initial count
    });
  });

  Object.values(graphData).forEach(entries => {
    if (Array.isArray(entries)) {
      entries.forEach(entry => {
        const dateObject = new Date(entry.dateRead);
        const hours = dateObject.getUTCHours(); // Extract hour from timestamp
        const timeSlot = Math.floor(hours / 2) * 2; // Determine slot (0, 2, 4, ..., 22)

        // Find the slot entry and update count
        const existing = result.find(item => item.x === timeSlot);
        if (existing) {
          existing.count += 1; // Increment count for this slot
        }
      });
    }
  });

  // console.log("Scatter Data Result: ", result);
  return result;
};

const ReadLogScatterPlot = ({ data }) => {
  // console.log("ReadLogScatter Plot Data: ", data);

  // Helper function to format time slots into AM/PM format
  const formatTimeSlot = (slot) => {
    const hour = slot;
    const period = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12; // Convert 0 to 12 for 12AM, etc.
    return `${formattedHour} ${period}`;
  };

  const totalCount = data.reduce((sum, entry) => sum + entry.count, 0); 

  const chartData = {
    datasets: [
      {
        label: `Reading Records (Total: ${totalCount})`, 
        data: data.map(entry => ({
          x: entry.x, // Time Slot (0, 2, 4, ..., 22)
          y: entry.count, // Count of readings in this time slot
          r: Math.min(entry.count * 2, 10) // Scale circle size
        })),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
        pointRadius: (context) => context.raw.r, // Circle size based on count
      },
    ],
  };

  const options = {
    scales: {
      x: {
        title: {
          display: true,
          text: 'Time Slots (AM/PM)',
          color: 'white',
        },
        ticks: {
          color: 'white',
          stepSize: 2,  
          callback: (value) => formatTimeSlot(value),
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Reading Count',
          color: 'white',
        },
        ticks: {
          color: 'white',
          stepSize: 1,  
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          color: 'white',
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const formattedTimeSlot = formatTimeSlot(tooltipItem.raw.x);
            return `Time Slot: ${formattedTimeSlot}, Read Count: ${tooltipItem.raw.y}`;
          },
        },
        titleColor: 'white',
        bodyColor: 'white',
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return <Scatter data={chartData} options={options} />;
};

const BUCKET_LABELS = [
  "0-10m","10-30m","30-60m",
  "1-2h","2-5h","5-10h",
  "10-25h",">25h"
];

const getTimeBucket = (ms) => {
  const min = ms / 60000;

  if (min <= 10) return 0;
  if (min <= 30) return 1;
  if (min <= 60) return 2;
  if (min <= 120) return 3;
  if (min <= 300) return 4;
  if (min <= 600) return 5;
  if (min <= 1500) return 6;
  return 7;
};

const buildPageTimeHeatmap = (logsByDate) => {
  const pageMap = {};
  let maxPage = 0;

  Object.values(logsByDate || {}).forEach(logs => {
    if (!Array.isArray(logs)) logs = [logs];

    logs.forEach(log => {
      const page = log?.pageNumber;
      const time = log?.readTimeInMiliseconds;

      if (!page || !time) return;

      const bucket = getTimeBucket(time);

      maxPage = Math.max(maxPage, page);

      if (!pageMap[page]) {
        pageMap[page] = Array(8).fill(0);
      }

      pageMap[page][bucket] += 1;
    });
  });

  const heatmap = [];

  for (let p = maxPage; p >=1 ; p--) {
    for (let b = 0; b < 8; b++) {
      heatmap.push({
        x: b,
        y: p - 1,
        count: pageMap[p]?.[b] || 0
      });
    }
  }

  return { heatmap, maxPage };
};

const ReadLogHeatmap = ({ data }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!data || typeof data !== "object" || Array.isArray(data)) {
      console.error("❌ Invalid data passed to heatmap");
      return;
    }

    const { heatmap, maxPage } = buildPageTimeHeatmap(data);

    if (!heatmap.length || maxPage === 0) {
      console.error("❌ No usable heatmap data");
      return;
    }

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const cellWidth = 70;
    const cellHeight = 14;
    const paddingLeft = 80;
    const paddingTop = 30;
    const paddingBottom = 60;

    const width = paddingLeft + 8 * cellWidth + 40;
    const height = paddingTop + maxPage * cellHeight + paddingBottom;

    canvas.width = width;
    canvas.height = height;

    // 🔥 Dark background
    ctx.fillStyle = "#000000";
    ctx.fillRect(0, 0, width, height);

    const maxCount = Math.max(...heatmap.map(d => d.count)) || 1;

    const getColor = (count) => {
      if (count === 0) return "#1a0000"; // very dark red

      const r = count / maxCount;

      if (r < 0.25) return "#4d0000";
      if (r < 0.5) return "#990000";
      if (r < 0.75) return "#ff1a1a";
      return "#ff6666";
    };

    // -----------------------
    // Y AXIS (ALL PAGES)
    // -----------------------
    ctx.fillStyle = "#FFD700";
    ctx.font = "10px Arial";
    ctx.textBaseline = "middle";

    for (let p = maxPage; p >=1; p--) {
      // if (maxPage <= 50 || p % 2 === 0) {
        const y = paddingTop + (p - 1) * cellHeight;
        ctx.fillText(`Pg ${p}`, 10, y + cellHeight / 2);
      // }
    }

    // -----------------------
    // X AXIS (TIME BUCKETS)
    // -----------------------
    ctx.fillStyle = "#FFD700";

    BUCKET_LABELS.forEach((label, i) => {
      const x = paddingLeft + i * cellWidth;
      ctx.fillText(label, x, height - 40);
    });

    // -----------------------
    // DRAW HEATMAP
    // -----------------------
    ctx.textAlign = "center";

    heatmap.forEach(({ x, y, count }) => {
      const posX = paddingLeft + x * cellWidth;
      // const posY = paddingTop + y * cellHeight;
      const posY = paddingTop + (maxPage - y - 1) * cellHeight;

      ctx.fillStyle = getColor(count);
      ctx.fillRect(posX, posY, cellWidth - 2, cellHeight - 2);

      // Data labels
      if (count > 0) {
        ctx.fillStyle = "#ffffff";
        ctx.font = "9px Arial";
        ctx.fillText(
          count,
          posX + cellWidth / 2,
          posY + cellHeight / 2
        );
      }
    });

    // -----------------------
    // LEGEND
    // -----------------------
    const legendX = paddingLeft;
    const legendY = height - 20;
    const legendWidth = 200;
    const legendHeight = 10;

    for (let i = 0; i <= 100; i++) {
      const value = i / 100;

      let color;
      if (value < 0.25) color = "#4d0000";   // lighter base (visible on black)
      else if (value < 0.5) color = "#990000";
      else if (value < 0.75) color = "#ff1a1a";
      else color = "#ff6666";  

      ctx.fillStyle = color;
      ctx.fillRect(
        legendX + (i * legendWidth) / 100,
        legendY,
        legendWidth / 100,
        legendHeight
      );
    }

    ctx.fillStyle = "#FFD700";
    ctx.font = "10px Arial";
    ctx.textAlign = "left";

    ctx.fillText("Low", legendX, legendY + 20);
    ctx.fillText("High", legendX + legendWidth - 30, legendY + 20);

  }, [data]);

  return (
    <div style={{ overflowX: "auto", background: "#000" }}>
      <canvas ref={canvasRef} />
    </div>
  );
};

const sampleData = [];

for (let day = 0; day < 7; day++) {
  for (let page = 0; page < 50; page++) {
    sampleData.push({
      x: day,        // 0-6 => days
      y: page,       // 0-49 => pages
      count: Math.floor(Math.random() * 25), // random read count
    });
  }
}

const buildViolinChartData = (logsByDate) => {
  if (!logsByDate || typeof logsByDate !== "object") return [];

  const timeBuckets = ["<2m", "2-5m", "5-15m", "15-30m", "30-60m", ">60m"];
  const orderedWeekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  // Initialise counts for every weekday
  const countsByDay = {};
  orderedWeekdays.forEach((day) => {
    countsByDay[day] = new Array(timeBuckets.length).fill(0);
  });

  Object.entries(logsByDate).forEach(([date, logs]) => {
    if (!Array.isArray(logs)) return;

    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return;

    const dow = dateObj.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
    const dayName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dow];

    logs.forEach((log) => {
      const minutes = (log.readTimeInMiliseconds || 0) / 60000;
      let bucket = 0;
      if (minutes < 2) bucket = 0;
      else if (minutes < 5) bucket = 1;
      else if (minutes < 15) bucket = 2;
      else if (minutes < 30) bucket = 3;
      else if (minutes < 60) bucket = 4;
      else bucket = 5;

      if (countsByDay[dayName]) countsByDay[dayName][bucket]++;
    });
  });

  // Return in Monday-to-Sunday order
  return orderedWeekdays.map((day) => ({
    day,
    counts: countsByDay[day],
  }));
};

const ReadLogViolinChart = ({ data }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!data || data.length === 0) {
      console.warn("Violin data is empty");
      return;
    }

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const width = 800;
    const height = 500;
    canvas.width = width;
    canvas.height = height;

    const padding = 75;
    const plotWidth = width - 2 * padding;
    const plotHeight = height - 2 * padding;

    // Background
    ctx.fillStyle = "#111";
    ctx.fillRect(0, 0, width, height);

    const timeBuckets = ["<2m", "2-5m", "5-15m", "15-30m", "30-60m", ">60m"];
    const numBuckets = timeBuckets.length;

    // Global max count for scaling width
    const maxCount = Math.max(...data.flatMap((d) => d.counts), 1);

    const xStep = plotWidth / data.length;
    const violinHalfWidth = xStep * 0.35; // perfect width for violin shape

    // === DRAW 7 VIOLINS ===
    data.forEach((dayData, i) => {
      const xCenter = padding + i * xStep + xStep / 2;

      ctx.beginPath();

      // LEFT side (bottom <2m → top >60m)
      for (let j = 0; j < numBuckets; j++) {
        const y = height - padding - (j / (numBuckets - 1)) * plotHeight;
        const w = (dayData.counts[j] / maxCount) * violinHalfWidth;
        if (j === 0) ctx.moveTo(xCenter - w, y);
        else ctx.lineTo(xCenter - w, y);
      }

      // RIGHT side (mirror – top to bottom)
      for (let j = numBuckets - 1; j >= 0; j--) {
        const y = height - padding - (j / (numBuckets - 1)) * plotHeight;
        const w = (dayData.counts[j] / maxCount) * violinHalfWidth;
        ctx.lineTo(xCenter + w, y);
      }

      ctx.closePath();

      ctx.fillStyle = "rgba(255, 100, 100, 0.75)";
      ctx.fill();
      ctx.strokeStyle = "#ff6666";
      ctx.lineWidth = 2.5;
      ctx.stroke();

      // Weekday label
      ctx.fillStyle = "#FFD700";
      ctx.font = "bold 14px sans-serif";
      ctx.textAlign = "center";
      ctx.fillText(dayData.day, xCenter, height - padding + 35);
    });

    // Axes
    ctx.strokeStyle = "#FFD700";
    ctx.lineWidth = 2;
    // Y-axis
    ctx.beginPath();
    ctx.moveTo(padding, padding);
    ctx.lineTo(padding, height - padding);
    ctx.stroke();
    // X-axis
    ctx.beginPath();
    ctx.moveTo(padding, height - padding);
    ctx.lineTo(width - padding, height - padding);
    ctx.stroke();

    // Y bucket labels
    ctx.fillStyle = "#FFD700";
    ctx.font = "13px sans-serif";
    ctx.textAlign = "right";
    for (let j = 0; j < numBuckets; j++) {
      const y = height - padding - (j / (numBuckets - 1)) * plotHeight;
      ctx.fillText(timeBuckets[j], padding - 15, y + 5);
    }

    // Titles
    ctx.font = "15px sans-serif";
    ctx.textAlign = "center";
    ctx.fillText("Weekday", width / 2, height - 5);

    ctx.save();
    ctx.translate(28, height / 2);
    ctx.rotate(-Math.PI / 2);
    ctx.fillText("Read Time Bucket", 0, 0);
    ctx.restore();
  }, [data]);

  return (
    <div style={{ overflowX: "auto", background: "#111", padding: "15px", borderRadius: "8px" }}>
      <canvas ref={canvasRef} />
    </div>
  );
};

const buildRadarChartData = (logsByDate) => {
  if (!logsByDate || typeof logsByDate !== 'object') return [];

  const orderedWeekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  
  // Initialize totals (in milliseconds)
  const totalsByDay = {};
  orderedWeekdays.forEach(day => {
    totalsByDay[day] = 0;
  });

  Object.entries(logsByDate).forEach(([dateStr, logs]) => {
    if (!Array.isArray(logs)) return;

    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return;

    const dow = dateObj.getDay();           // 0 = Sun, 1 = Mon, ..., 6 = Sat
    const dayName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dow];

    logs.forEach(log => {
      const ms = Number(log.readTimeInMiliseconds) || 0;
      if (totalsByDay[dayName] !== undefined) {
        totalsByDay[dayName] += ms;
      }
    });
  });

  // Convert to array in Mon→Sun order + format nicely
  return orderedWeekdays.map(day => ({
    day,
    totalMs: totalsByDay[day],
    // We'll format to h:m:s inside the chart component
  }));
};

const ReadLogRadarChart = ({ data, title = "Weekly Reading Time Pattern" }) => {
  const canvasRef = useRef(null);

  // Helper: ms → "Xh Ym Zs"  (omits zero parts, but always shows at least "0s")
  const formatTime = (ms) => {
    if (!ms) return "0s";
    const totalSec = Math.floor(ms / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;

    const parts = [];
    if (h > 0) parts.push(`${h}h`);
    if (m > 0) parts.push(`${m}m`);
    if (s > 0 || parts.length === 0) parts.push(`${s}s`);
    return parts.join(" ");
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const width = 700;
    const height = 700;
    canvas.width = width;
    canvas.height = height;

    const centerX = width / 2;
    const centerY = height / 2;
    const radius = Math.min(width, height) / 2 - 100; // margin for labels

    // Background
    ctx.fillStyle = "#111";
    ctx.fillRect(0, 0, width, height);

    if (!data || data.length === 0) {
      ctx.fillStyle = "#888";
      ctx.font = "20px sans-serif";
      ctx.textAlign = "center";
      ctx.fillText("No reading data available", centerX, centerY);
      return;
    }

    // Find max total time (for scaling)
    const maxMs = Math.max(...data.map(d => d.totalMs), 1);
    const levels = 5; // concentric circles

    // === Draw concentric circles + axis lines ===
    ctx.strokeStyle = "rgba(255, 215, 0, 0.25)"; // gold-ish faint
    ctx.lineWidth = 1;

    for (let i = 1; i <= levels; i++) {
      const r = (radius / levels) * i;
      ctx.beginPath();
      ctx.arc(centerX, centerY, r, 0, Math.PI * 2);
      ctx.stroke();

      // Label max time at outer ring
      if (i === levels) {
        ctx.fillStyle = "#FFD700";
        ctx.font = "14px sans-serif";
        ctx.textAlign = "center";
        ctx.fillText(formatTime(maxMs), centerX + 20, centerY - r - 10);
      }
    }

    // === Draw axes (7 spokes) + weekday labels ===
    const angleStep = (Math.PI * 2) / 7;
    const labels = data.map(d => d.day);

    ctx.strokeStyle = "rgba(255, 215, 0, 0.6)";
    ctx.lineWidth = 1.5;

    labels.forEach((label, i) => {
      const angle = i * angleStep - Math.PI / 2; // start at top

      // Spoke line
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.lineTo(
        centerX + radius * Math.cos(angle),
        centerY + radius * Math.sin(angle)
      );
      ctx.stroke();

      // Weekday label
      const labelRadius = radius + 35;
      const lx = centerX + labelRadius * Math.cos(angle);
      const ly = centerY + labelRadius * Math.sin(angle);

      ctx.fillStyle = "#FFD700";
      ctx.font = "bold 15px sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(label, lx, ly);
    });

    // === Draw the actual radar polygon ===
    ctx.beginPath();
    data.forEach((entry, i) => {
      const angle = i * angleStep - Math.PI / 2;
      const valueRatio = entry.totalMs / maxMs;
      const px = centerX + radius * valueRatio * Math.cos(angle);
      const py = centerY + radius * valueRatio * Math.sin(angle);

      if (i === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    });
    ctx.closePath();

    ctx.fillStyle = "rgba(100, 200, 255, 0.35)";   // light blue fill
    ctx.fill();
    ctx.strokeStyle = "#00BFFF";                    // bright blue line
    ctx.lineWidth = 3;
    ctx.stroke();

    // === Draw points + time labels on each axis ===
    data.forEach((entry, i) => {
      const angle = i * angleStep - Math.PI / 2;
      const valueRatio = entry.totalMs / maxMs;
      const px = centerX + radius * valueRatio * Math.cos(angle);
      const py = centerY + radius * valueRatio * Math.sin(angle);

      // Point
      ctx.fillStyle = "#00BFFF";
      ctx.beginPath();
      ctx.arc(px, py, 6, 0, Math.PI * 2);
      ctx.fill();

      // Time label near point (slightly offset outward)
      const labelRadius = radius * valueRatio + 18;
      const lx = centerX + labelRadius * Math.cos(angle);
      const ly = centerY + labelRadius * Math.sin(angle);

      ctx.fillStyle = "#e0f7ff";
      ctx.font = "13px sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(formatTime(entry.totalMs), lx, ly);
    });

    // Title
    ctx.fillStyle = "#FFD700";
    ctx.font = "22px sans-serif";
    ctx.textAlign = "center";
    ctx.fillText(title, centerX, 45);

  }, [data, title]);

  return (
    <div style={{
      background: "#111",
      padding: "20px",
      borderRadius: "12px",
      overflow: "auto"
    }}>
      <canvas ref={canvasRef} style={{ display: "block", margin: "0 auto" }} />
    </div>
  );
};

const buildWeekdaySummaryData = (logsByDate) => {
  if (!logsByDate || typeof logsByDate !== 'object') return [];

  const orderedWeekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  // accumulators
  const summary = {};
  orderedWeekdays.forEach(day => {
    summary[day] = {
      totalMs: 0,
      sessions: [],           // keep individual session times (ms)
      count: 0
    };
  });

  Object.entries(logsByDate).forEach(([dateStr, logs]) => {
    if (!Array.isArray(logs)) return;

    const dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) return;

    const dow = dateObj.getDay(); // 0=Sun ... 6=Sat
    const dayName = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][dow];

    if (!summary[dayName]) return;

    logs.forEach(log => {
      const ms = Number(log.readTimeInMiliseconds) || 0;
      if (ms <= 0) return;

      summary[dayName].totalMs += ms;
      summary[dayName].sessions.push(ms);
      summary[dayName].count++;
    });
  });

  return orderedWeekdays
    .map(day => {
      const s = summary[day];
      if (s.count === 0) return null;

      const sessionsMin = s.sessions.length > 0 ? Math.min(...s.sessions) : 0;
      const sessionsMax = s.sessions.length > 0 ? Math.max(...s.sessions) : 0;

      return {
        day,
        totalMs: s.totalMs,
        totalMinutes: s.totalMs / 60000,
        minSessionMs: sessionsMin,
        maxSessionMs: sessionsMax,
        count: s.count
      };
    })
    .filter(Boolean); // remove days with no data
};

const ReadLogBoxPlotChart = ({ data, title = "Total Reading Time & Session Range per Weekday" }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const W = 880;
    const H = 580;
    canvas.width = W;
    canvas.height = H;

    const pad = { top: 80, right: 60, bottom: 100, left: 90 };
    const plotW = W - pad.left - pad.right;
    const plotH = H - pad.top - pad.bottom;

    ctx.fillStyle = '#0d1117';
    ctx.fillRect(0, 0, W, H);

    if (!data || data.length === 0) {
      ctx.fillStyle = '#888';
      ctx.font = '20px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('No data', W/2, H/2);
      return;
    }

    // Find global max for scaling (use total time or max session — usually total is bigger)
    const maxY = Math.max(
      ...data.map(d => d.totalMinutes),
      ...data.map(d => d.maxSessionMs / 60000)
    ) * 1.15 || 60;

    const xStep = plotW / data.length;
    const barWidth = Math.min(70, xStep * 0.65);
    const lineWidth = 4;

    const scaleY = v => pad.top + plotH - (v / maxY) * plotH;

    // Grid
    ctx.strokeStyle = 'rgba(100,120,140,0.3)';
    for (let i = 0; i <= 6; i++) {
      const y = pad.top + (plotH/6)*i;
      ctx.beginPath();
      ctx.moveTo(pad.left, y);
      ctx.lineTo(W - pad.right, y);
      ctx.stroke();
    }

    data.forEach((d, i) => {
      const x = pad.left + i * xStep + xStep/2;

      const yTotal   = scaleY(d.totalMinutes);
      const yMinSess = scaleY(d.minSessionMs / 60000);
      const yMaxSess = scaleY(d.maxSessionMs / 60000);

      // Thin range line (session min → max)
      ctx.strokeStyle = '#555';
      ctx.lineWidth = lineWidth;
      ctx.beginPath();
      ctx.moveTo(x, yMinSess);
      ctx.lineTo(x, yMaxSess);
      ctx.stroke();

      // Thick marker for TOTAL time
      ctx.strokeStyle = d.totalMinutes > 30 ? '#4caf50' : '#ff9800';
      ctx.lineWidth = 14;
      ctx.beginPath();
      ctx.moveTo(x - barWidth/2, yTotal);
      ctx.lineTo(x + barWidth/2, yTotal);
      ctx.stroke();

      // Small circle at total
      ctx.fillStyle = ctx.strokeStyle;
      ctx.beginPath();
      ctx.arc(x, yTotal, 7, 0, Math.PI*2);
      ctx.fill();

      // Labels
      ctx.fillStyle = '#e0e0ff';
      ctx.font = '12px sans-serif';
      ctx.textAlign = 'center';

      // total time label above marker
      ctx.fillText(`${Math.round(d.totalMinutes)} min total`, x, yTotal - 18);

      // min / max session labels
      if (d.minSessionMs > 0) {
        ctx.fillStyle = '#aaa';
        ctx.fillText(`${Math.round(d.minSessionMs/60000)} min`, x, yMinSess + 18);
      }
      ctx.fillText(`${Math.round(d.maxSessionMs/60000)} min`, x, yMaxSess - 8);

      // Day + count
      ctx.fillStyle = '#c9d1d9';
      ctx.font = 'bold 15px sans-serif';
      ctx.fillText(d.day, x, H - pad.bottom + 30);

      ctx.font = '12px sans-serif';
      ctx.fillStyle = '#8b949e';
      ctx.fillText(`n=${d.count}`, x, H - pad.bottom + 55);
    });

    // Y axis & ticks
    ctx.strokeStyle = '#58a6ff';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(pad.left, pad.top);
    ctx.lineTo(pad.left, H - pad.bottom);
    ctx.stroke();

    ctx.fillStyle = '#c9d1d9';
    ctx.font = '13px sans-serif';
    ctx.textAlign = 'right';
    for (let i = 0; i <= 6; i++) {
      const v = (maxY / 6) * i;
      const y = pad.top + (plotH / 6) * (6 - i);
      ctx.fillText(`${Math.round(v)} min`, pad.left - 12, y + 4);
    }

    // Titles
    ctx.fillStyle = '#58a6ff';
    ctx.font = '22px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(title, W/2, pad.top - 35);

    ctx.font = '16px sans-serif';
    ctx.fillText("Weekdays", W/2, H - 25);

    ctx.save();
    ctx.translate(45, H/2);
    ctx.rotate(-Math.PI/2);
    ctx.textAlign = 'center';
    ctx.fillText("Time (minutes)", 0, 0);
    ctx.restore();

  }, [data]);

  return (
    <div style={{ background: '#0d1117', padding: '20px', borderRadius: '10px', overflowX: 'auto' }}>
      <canvas ref={canvasRef} style={{ display: 'block', margin: '0 auto' }} />
    </div>
  );
};

// const simulateAreaChartData = () => {
//   const days = 10;
//   const users = ['Sanjeev', 'Vijay', 'Muzaffar'];
//   return Array.from({ length: days }, (_, i) => {
//     const entry = { day: `Day ${i + 1}` };
//     users.forEach(user => {
//       entry[user] = Math.floor(Math.random() * 20 + 5); // Random 5–25 pages
//     });
//     return entry;
//   });
// };

const buildAreaChartData = (logsByDate) => {
  if (!logsByDate || typeof logsByDate !== "object") return [];

  const monthData = {}; // key: "2025-01" → { Mon: totalMs, Tue: totalMs, ... }

  Object.entries(logsByDate).forEach(([dateStr, logs]) => {
    if (!Array.isArray(logs)) return;

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const monthKey = `${year}-${month}`;

    const dow = date.getDay(); // 0=Sun ... 6=Sat
    const dayName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dow];

    if (!monthData[monthKey]) {
      monthData[monthKey] = { Sun: 0, Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0 };
    }

    logs.forEach((log) => {
      const ms = Number(log.readTimeInMiliseconds) || 0;
      if (ms > 0) {
        monthData[monthKey][dayName] += ms;
      }
    });
  });

  // Sort chronologically
  const sortedMonthKeys = Object.keys(monthData).sort();

  return sortedMonthKeys.map((key) => {
    const dayTotalsMs = monthData[key];
    const dayMinutes = {};
    let totalMinutes = 0;

    Object.keys(dayTotalsMs).forEach((day) => {
      dayMinutes[day] = dayTotalsMs[day] / 60000;
      totalMinutes += dayMinutes[day];
    });

    const label = new Date(key + "-01").toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    });

    return {
      monthKey: key,
      label,
      ...dayMinutes,           // Sun, Mon, Tue, ..., Sat in minutes
      totalMinutes,
    };
  });
};

// const ReadLogAreaChart = ({ data, title = "Monthly Reading Time by Weekday" }) => {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const ctx = canvas.getContext("2d");

//     const width = 920;
//     const height = 580;
//     canvas.width = width;
//     canvas.height = height;

//     const padding = { top: 80, right: 70, bottom: 90, left: 90 };
//     const plotWidth = width - padding.left - padding.right;
//     const plotHeight = height - padding.top - padding.bottom;

//     // Background
//     ctx.fillStyle = "#0d1117";
//     ctx.fillRect(0, 0, width, height);

//     if (!data || data.length === 0) {
//       ctx.fillStyle = "#888";
//       ctx.font = "20px sans-serif";
//       ctx.textAlign = "center";
//       ctx.fillText("No reading data for area chart", width / 2, height / 2);
//       return;
//     }

//     // Find global max for scaling
//     const maxTotal = Math.max(...data.map((d) => d.totalMinutes), 10);

//     const xStep = plotWidth / (data.length - 1 || 1);
//     const yScale = plotHeight / maxTotal;

//     // Weekday order for stacking (Mon → Sun)
//     const weekdayOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
//     const colors = {
//       Mon: "#4D96FF",
//       Tue: "#6BCB77",
//       Wed: "#FFDD57",
//       Thu: "#FF6B6B",
//       Fri: "#C77DFF",
//       Sat: "#FF9F1C",
//       Sun: "#00D4AA",
//     };

//     // Build stacked cumulative values for each month
//     const stacked = data.map((month, i) => {
//       let cumulative = 0;
//       const layerY = {};
//       weekdayOrder.forEach((day) => {
//         cumulative += month[day] || 0;
//         layerY[day] = cumulative;
//       });
//       return { x: padding.left + i * xStep, layers: layerY };
//     });

//     // Draw stacked areas (bottom to top)
//     weekdayOrder.forEach((day, idx) => {
//       ctx.beginPath();
//       // Top of this layer
//       ctx.moveTo(stacked[0].x, height - padding.bottom - stacked[0].layers[day] * yScale);

//       stacked.forEach((point, i) => {
//         ctx.lineTo(point.x, height - padding.bottom - point.layers[day] * yScale);
//       });

//       // Close to baseline (bottom of chart)
//       for (let i = stacked.length - 1; i >= 0; i--) {
//         const baseY = height - padding.bottom - (idx === 0 ? 0 : stacked[i].layers[weekdayOrder[idx - 1]] * yScale);
//         ctx.lineTo(stacked[i].x, baseY);
//       }
//       ctx.closePath();

//       ctx.fillStyle = colors[day];
//       ctx.globalAlpha = 0.75;
//       ctx.fill();

//       // Subtle stroke for separation
//       ctx.strokeStyle = "#111";
//       ctx.lineWidth = 1.5;
//       ctx.stroke();
//       ctx.globalAlpha = 1;
//     });

//     // Horizontal grid lines
//     ctx.strokeStyle = "rgba(120, 130, 150, 0.3)";
//     ctx.lineWidth = 1;
//     for (let i = 0; i <= 6; i++) {
//       const y = padding.top + (plotHeight / 6) * i;
//       ctx.beginPath();
//       ctx.moveTo(padding.left, y);
//       ctx.lineTo(width - padding.right, y);
//       ctx.stroke();
//     }

//     // X-axis labels (Month)
//     ctx.fillStyle = "#e0f0ff";
//     ctx.font = "bold 13px sans-serif";
//     ctx.textAlign = "center";
//     data.forEach((month, i) => {
//       const x = padding.left + i * xStep;
//       ctx.fillText(month.label, x, height - padding.bottom + 38);
//     });

//     // Y-axis
//     ctx.strokeStyle = "#58a6ff";
//     ctx.lineWidth = 2;
//     ctx.beginPath();
//     ctx.moveTo(padding.left, padding.top);
//     ctx.lineTo(padding.left, height - padding.bottom);
//     ctx.stroke();

//     // Y ticks (minutes)
//     ctx.fillStyle = "#c9d1d9";
//     ctx.font = "13px sans-serif";
//     ctx.textAlign = "right";
//     for (let i = 0; i <= 6; i++) {
//       const val = (maxTotal / 6) * i;
//       const y = padding.top + (plotHeight / 6) * (6 - i);
//       const display = val >= 60 ? `${(val / 60).toFixed(1)}h` : `${Math.round(val)}m`;
//       ctx.fillText(display, padding.left - 14, y + 4);

//       ctx.beginPath();
//       ctx.moveTo(padding.left - 7, y);
//       ctx.lineTo(padding.left, y);
//       ctx.stroke();
//     }

//     // Title
//     ctx.fillStyle = "#58a6ff";
//     ctx.font = "24px sans-serif";
//     ctx.textAlign = "center";
//     ctx.fillText(title, width / 2, padding.top - 35);

//     // Legend (7 weekdays)
//     const legendX = width - padding.right - 140;
//     let legendY = padding.top + 20;
//     weekdayOrder.forEach((day) => {
//       ctx.fillStyle = colors[day];
//       ctx.fillRect(legendX, legendY, 18, 10);
//       ctx.fillStyle = "#e0f0ff";
//       ctx.font = "13px sans-serif";
//       ctx.fillText(day, legendX + 28, legendY + 9);
//       legendY += 24;
//     });

//     // Axis labels
//     ctx.save();
//     ctx.translate(38, height / 2);
//     ctx.rotate(-Math.PI / 2);
//     ctx.textAlign = "center";
//     ctx.fillStyle = "#58a6ff";
//     ctx.font = "16px sans-serif";
//     ctx.fillText("Total Reading Time", 0, 0);
//     ctx.restore();

//     ctx.fillStyle = "#58a6ff";
//     ctx.font = "16px sans-serif";
//     ctx.textAlign = "center";
//     ctx.fillText("Month", width / 2, height - 18);
//   }, [data]);

//   return (
//     <div
//       style={{
//         background: "#0d1117",
//         padding: "24px",
//         borderRadius: "12px",
//         overflowX: "auto",
//         border: "1px solid #30363d",
//       }}
//     >
//       <canvas ref={canvasRef} style={{ display: "block", margin: "0 auto" }} />
//     </div>
//   );
// };

// const buildTimeOfDayData = (logsByDate) => {
//   if (!logsByDate || typeof logsByDate !== "object") return [];

//   // 24-hour buckets
//   const hourData = Array.from({ length: 24 }, (_, h) => ({
//     hour: h,
//     label: `${h.toString().padStart(2, "0")}:00`,
//     totalMs: 0,
//     sessions: 0,
//   }));

//   // Flatten all logs and bin by hour
//   Object.values(logsByDate)
//     .flat()
//     .forEach((log) => {
//       if (!log.dateRead) return;
//       const date = new Date(log.dateRead);
//       if (isNaN(date.getTime())) return;

//       const hour = date.getHours();
//       const ms = Number(log.readTimeInMiliseconds) || 0;

//       if (ms > 0) {
//         hourData[hour].totalMs += ms;
//         hourData[hour].sessions++;
//       }
//     });

//   return hourData.map((h) => ({
//     ...h,
//     totalMinutes: Math.round(h.totalMs / 60000),
//   }));
// };

// const ReadLogTimeOfDayChart = ({ data, title = "Reading Patterns by Time of Day" }) => {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const ctx = canvas.getContext("2d");

//     const width = 920;
//     const height = 560;
//     canvas.width = width;
//     canvas.height = height;

//     const padding = { top: 80, right: 60, bottom: 90, left: 80 };
//     const plotWidth = width - padding.left - padding.right;
//     const plotHeight = height - padding.top - padding.bottom;

//     ctx.fillStyle = "#0d1117";
//     ctx.fillRect(0, 0, width, height);

//     if (!data || data.length === 0) {
//       ctx.fillStyle = "#888";
//       ctx.font = "20px sans-serif";
//       ctx.textAlign = "center";
//       ctx.fillText("No reading data", width / 2, height / 2);
//       return;
//     }

//     const maxMinutes = Math.max(...data.map((d) => d.totalMinutes), 10);
//     const xStep = plotWidth / 23; // 24 points, 23 steps
//     const scaleY = (val) => padding.top + plotHeight - (val / maxMinutes) * plotHeight;

//     // === Gradient Area Fill ===
//     ctx.beginPath();
//     ctx.moveTo(padding.left, height - padding.bottom);

//     data.forEach((point, i) => {
//       const x = padding.left + i * xStep;
//       const y = scaleY(point.totalMinutes);
//       if (i === 0) ctx.lineTo(x, y);
//       else ctx.lineTo(x, y);
//     });

//     ctx.lineTo(padding.left + 23 * xStep, height - padding.bottom);
//     ctx.closePath();

//     // Beautiful gradient
//     const gradient = ctx.createLinearGradient(0, padding.top, 0, height - padding.bottom);
//     gradient.addColorStop(0, "rgba(0, 200, 255, 0.85)");
//     gradient.addColorStop(1, "rgba(0, 200, 255, 0.05)");
//     ctx.fillStyle = gradient;
//     ctx.fill();

//     // Subtle stroke on area
//     ctx.strokeStyle = "#00ccff";
//     ctx.lineWidth = 3.5;
//     ctx.stroke();

//     // === Bars + Labels ===
//     data.forEach((point, i) => {
//       const x = padding.left + i * xStep;
//       const y = scaleY(point.totalMinutes);
//       const barHeight = (height - padding.bottom) - y;

//       // Thin bar
//       ctx.fillStyle = i % 2 === 0 ? "rgba(0, 180, 255, 0.25)" : "rgba(0, 220, 255, 0.18)";
//       ctx.fillRect(x - 6, y, 12, barHeight);

//       // Session count label
//       if (point.sessions > 0) {
//         ctx.fillStyle = "#e0f7ff";
//         ctx.font = "10px sans-serif";
//         ctx.textAlign = "center";
//         ctx.fillText(`${point.sessions}`, x, y - 8);
//       }

//       // Hour label
//       ctx.fillStyle = "#c9d1d9";
//       ctx.font = "11px sans-serif";
//       ctx.fillText(point.label, x, height - padding.bottom + 28);
//     });

//     // Highlight peak hours
//     const peakHour = data.reduce((max, curr) =>
//       curr.totalMinutes > max.totalMinutes ? curr : max
//     );
//     const peakX = padding.left + peakHour.hour * xStep;
//     const peakY = scaleY(peakHour.totalMinutes);

//     ctx.fillStyle = "#ffd700";
//     ctx.font = "bold 13px sans-serif";
//     ctx.textAlign = "center";
//     ctx.fillText("PEAK", peakX, peakY - 28);
//     ctx.beginPath();
//     ctx.arc(peakX, peakY, 5, 0, Math.PI * 2);
//     ctx.fill();

//     // Y-axis
//     ctx.strokeStyle = "#58a6ff";
//     ctx.lineWidth = 2;
//     ctx.beginPath();
//     ctx.moveTo(padding.left, padding.top);
//     ctx.lineTo(padding.left, height - padding.bottom);
//     ctx.stroke();

//     // Y ticks
//     ctx.fillStyle = "#c9d1d9";
//     ctx.font = "12px sans-serif";
//     ctx.textAlign = "right";
//     for (let i = 0; i <= 6; i++) {
//       const val = (maxMinutes / 6) * i;
//       const y = padding.top + (plotHeight / 6) * (6 - i);
//       const label = val >= 60 ? `${(val / 60).toFixed(1)}h` : `${Math.round(val)}m`;
//       ctx.fillText(label, padding.left - 12, y + 4);
//     }

//     // Title & axis labels
//     ctx.fillStyle = "#58a6ff";
//     ctx.font = "24px sans-serif";
//     ctx.textAlign = "center";
//     ctx.fillText(title, width / 2, padding.top - 35);

//     ctx.font = "16px sans-serif";
//     ctx.fillText("Hour of Day", width / 2, height - 20);

//     ctx.save();
//     ctx.translate(35, height / 2);
//     ctx.rotate(-Math.PI / 2);
//     ctx.textAlign = "center";
//     ctx.fillText("Total Reading Minutes", 0, 0);
//     ctx.restore();
//   }, [data]);

//   return (
//     <div
//       style={{
//         background: "#0d1117",
//         padding: "24px",
//         borderRadius: "12px",
//         overflowX: "auto",
//         border: "1px solid #30363d",
//       }}
//     >
//       <canvas ref={canvasRef} style={{ display: "block", margin: "0 auto" }} />
//     </div>
//   );
// };

const buildTimeOfDayByWeekdayData = (logsByDate) => {
  if (!logsByDate || typeof logsByDate !== 'object') return [];

  // 24 hours × 7 weekdays
  const hourWeekdayData = Array.from({ length: 24 }, () =>
    ({ Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0 })
  );

  Object.values(logsByDate)
    .flat()
    .forEach((log) => {
      if (!log.dateRead) return;
      const date = new Date(log.dateRead);
      if (isNaN(date.getTime())) return;

      const hour = date.getHours();
      const dow = date.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
      const dayName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dow];

      const ms = Number(log.readTimeInMiliseconds) || 0;
      if (ms > 0) {
        hourWeekdayData[hour][dayName] += ms / 60000; // minutes
      }
    });

  // Convert to array of objects for easier charting
  return hourWeekdayData.map((hourSlots, h) => ({
    hour: h,
    label: `${h.toString().padStart(2, '0')}:00`,
    ...hourSlots,
    totalMinutes: Object.values(hourSlots).reduce((a, b) => a + b, 0),
  }));
};


const ReadLogAreaChart = ({ data, title = "Reading Patterns by Time of Day & Weekday" }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const width = 960;
    const height = 620;
    canvas.width = width;
    canvas.height = height;

    const padding = { top: 90, right: 80, bottom: 100, left: 90 };
    const plotWidth = width - padding.left - padding.right;
    const plotHeight = height - padding.top - padding.bottom;

    ctx.fillStyle = '#0d1117';
    ctx.fillRect(0, 0, width, height);

    if (!data || data.length === 0) {
      ctx.fillStyle = '#888';
      ctx.font = '20px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('No reading data', width / 2, height / 2);
      return;
    }

    const maxTotal = Math.max(...data.map(d => d.totalMinutes), 10);
    const xStep = plotWidth / 23;

    const scaleY = val => padding.top + plotHeight - (val / maxTotal) * plotHeight;

    // Fixed stacking order: Monday at bottom → Sunday at top
    const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const colors = {
      Mon: 'rgba(88, 166, 255, 0.78)',     // blue
      Tue: 'rgba(107, 203, 119, 0.78)',    // green
      Wed: 'rgba(255, 221, 87, 0.78)',     // yellow
      Thu: 'rgba(255, 107, 107, 0.78)',    // red
      Fri: 'rgba(199, 125, 255, 0.78)',    // purple
      Sat: 'rgba(255, 159, 28, 0.78)',     // orange
      Sun: 'rgba(0, 212, 170, 0.78)',      // teal
    };

    // Build cumulative layers — Mon first (base), Sun last (top)
    const layers = weekdays.map(() => []);
    data.forEach(point => {
      let cumulative = 0;
      weekdays.forEach(day => {
        cumulative += point[day] || 0;
        layers[weekdays.indexOf(day)].push(cumulative);
      });
    });

    // Draw areas from bottom to top (Mon → Sun)
    weekdays.forEach((day, layerIdx) => {
      ctx.beginPath();
      ctx.moveTo(padding.left, height - padding.bottom);

      data.forEach((_, i) => {
        const x = padding.left + i * xStep;
        const y = scaleY(layers[layerIdx][i]);
        ctx.lineTo(x, y);
      });

      ctx.lineTo(padding.left + 23 * xStep, height - padding.bottom);
      ctx.closePath();

      ctx.fillStyle = colors[day];
      ctx.fill();

      // Subtle border
      ctx.strokeStyle = colors[day].replace('0.78', '1.0');
      ctx.lineWidth = 1.2;
      ctx.stroke();
    });

    // Grid lines
    ctx.strokeStyle = 'rgba(100,120,140,0.35)';
    ctx.lineWidth = 1;
    for (let i = 0; i <= 6; i++) {
      const y = padding.top + (plotHeight / 6) * i;
      ctx.beginPath();
      ctx.moveTo(padding.left, y);
      ctx.lineTo(width - padding.right, y);
      ctx.stroke();
    }

    // X labels (every 3 hours + midnight & 23:00)
    ctx.fillStyle = '#c9d1d9';
    ctx.font = '13px sans-serif';
    ctx.textAlign = 'center';
    [0, 3, 6, 9, 12, 15, 18, 21, 23].forEach(h => {
      const x = padding.left + h * xStep;
      ctx.fillText(data[h]?.label || `${h}:00`, x, height - padding.bottom + 38);
    });

    // Y-axis & labels
    ctx.strokeStyle = '#58a6ff';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(padding.left, padding.top);
    ctx.lineTo(padding.left, height - padding.bottom);
    ctx.stroke();

    ctx.fillStyle = '#c9d1d9';
    ctx.font = '13px sans-serif';
    ctx.textAlign = 'right';
    for (let i = 0; i <= 6; i++) {
      const val = (maxTotal / 6) * i;
      const y = padding.top + (plotHeight / 6) * (6 - i);
      const label = val >= 60 ? `${(val/60).toFixed(1)} h` : `${Math.round(val)} min`;
      ctx.fillText(label, padding.left - 14, y + 4);
    }

    // Title & axis labels
    ctx.fillStyle = '#58a6ff';
    ctx.font = '24px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(title, width / 2, padding.top - 40);

    ctx.font = '17px sans-serif';
    ctx.fillText("Hour of Day", width / 2, height - 25);

    ctx.save();
    ctx.translate(38, height / 2);
    ctx.rotate(-Math.PI / 2);
    ctx.textAlign = 'center';
    ctx.fillText("Total Reading Minutes", 0, 0);
    ctx.restore();

    // Legend (shows stacking order)
    const legendX = width - padding.right - 170;
    let legendY = padding.top + 10;
    weekdays.forEach(day => {
      ctx.fillStyle = colors[day];
      ctx.fillRect(legendX, legendY, 18, 12);
      ctx.fillStyle = '#e0f0ff';
      ctx.font = '13px sans-serif';
      ctx.fillText(day, legendX + 28, legendY + 10);
      legendY += 26;
    });

    // Small note about stacking
    ctx.fillStyle = '#aaa';
    ctx.font = '11px sans-serif';
    ctx.fillText("Stacked: Mon at bottom → Sun at top", legendX, legendY + 20);

  }, [data]);

  return (
    <div style={{
      background: '#0d1117',
      padding: '24px',
      borderRadius: '12px',
      overflowX: 'auto',
      border: '1px solid #30363d'
    }}>
      <canvas ref={canvasRef} style={{ display: 'block', margin: '0 auto' }} />
    </div>
  );
};

const chartInfo = [
  {
    name: 'Bar Graph',
    usage: 'Compare reading counts across different days, users, or books.',
    why: 'Effective for showing quantity-based comparisons.',
    xAxis: 'Categories (e.g., Days, Book Titles, Users)',
    yAxis: 'Count of Pages Read / Reading Sessions',
    content: 'Bars representing total pages read or time spent.',
    extra: 'Grouped or stacked bars; summary views by week or month.'
  },
  {
    name: 'Line Chart',
    usage: 'Show reading progress or trends over time.',
    why: 'Highlights reading consistency or fluctuations.',
    xAxis: 'Time (Days, Weeks)',
    yAxis: 'Pages Read / Minutes Read',
    content: 'Points joined by lines representing progression.',
    extra: 'Show trendlines, display reading goals overlaid.'
  },
  {
    name: 'Pie Chart',
    usage: 'Show proportions of time/pages spent across books or genres.',
    why: 'Visualizes contribution of each item to a whole.',
    xAxis: '—',
    yAxis: '—',
    content: 'Slices representing book title or genre share.',
    extra: 'Drill-down into slices; individual vs group splits.'
  },
  {
    name: 'Scatter Chart',
    usage: 'Explore relationships (e.g., reading time vs pages).',
    why: 'Detects patterns, outliers, or correlations.',
    xAxis: 'Pages Read',
    yAxis: 'Time Spent',
    content: 'Dots representing sessions or users.',
    extra: 'Color-code by user/book type; add regression line.'
  },
  {
    name: 'Heatmap',
    usage: 'Identify reading intensity across time or categories.',
    why: 'Great for habit pattern discovery.',
    xAxis: 'Days or Dates',
    yAxis: 'Users or Books',
    content: 'Color-coded blocks (darker = more reading).',
    extra: 'Weekly/monthly views, filter by genre/user.'
  },
  {
    name: 'Radar Chart',
    usage: 'Visualize distribution of reading activity across multiple dimensions.',
    why: 'Helps identify patterns in reading time, page coverage, and session frequency.',
    xAxis: 'Days of the week or Users',
    yAxis: 'Number of sessions, pages read, or time spent',
    content: 'Symmetrical radial plot showing relative intensities across categories.',
    extra: 'Compare weekdays vs weekends, users vs books, or filter by demographics.'
  },
  {
    name: 'Violin Chart',
    usage: 'Show distribution and density of reading times/pages.',
    why: 'Combines boxplot + KDE for deep insight.',
    xAxis: 'Day or User',
    yAxis: 'Reading Sessions or Pages',
    content: 'Symmetrical plot showing reading frequency.',
    extra: 'Compare weekday vs weekend; filter by demographics.'
  },
  {
    name: 'Boxplot',
    usage: 'Summarize variation and detect outliers in sessions.',
    why: 'Highlights median, quartiles, and extremes.',
    xAxis: 'Days or Books',
    yAxis: 'Pages Read or Minutes',
    content: 'Box with min, max, median, and quartiles.',
    extra: 'User-wise comparisons; overlay with scatter.'
  },
  {
    name: "Stacked Area Chart",
    usage: "Visualize cumulative reading progress over time.",
    why: "Emphasizes total volume and individual contributions.",
    xAxis: "Time (Days, Weeks, Months)",
    yAxis: "Total Pages Read or Total Reading Time",
    content: "Stacked areas showing individual contributions to the group total.",
    extra: "Ideal for group reading tracking; interactive layers can show individual trends."
  },
];

const roadmap = [
  "📅 Time of Day Analysis – Morning vs Evening habits",
  "📚 Genre-Wise Preferences – Fiction vs Non-Fiction",
  "🎯 Goal Tracking – Completion %, daily/weekly targets",
  "🗓️ Calendar Heatmaps – Monthly streak and volume",
  "🏅 Compare with Peers – Leaderboards, top readers",
  "⚡ Reading Speed – Pages per minute per session",
  "💬 Sentiment Maps – Emotional response to books",
  "🕰️ Timeline View – Milestones and streaks",
  "📈 Radar Charts – Speed, consistency, diversity in one view"
];

const ReadLogBigDataHelp = ({ title }) => {
  return (
    <div className="max-w-6xl mx-auto p-4 [&_p]:text-gray-100">
      <h2 className="text-2xl font-bold text-center mb-6">{title}</h2>
      <h2 className="text-xl text-yellow-200 font-bold text-center mb-6">How These Graphs or Insights can be useful to Teachers, Administrators, Govt. Officer, Ministry, Parents, Students</h2>     
      <div className="grid md:grid-cols-2 gap-6">
        {chartInfo.map((chart, idx) => (
          <div key={idx} className="border rounded-xl p-4 shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold text-yellow-200 mb-2">{chart.name}</h3>
            <p className='text-white'><strong>📌 Usage:</strong> {chart.usage}</p>
            <p><strong>🤔 Why:</strong> {chart.why}</p>
            <p><strong>📊 X-Axis:</strong> {chart.xAxis}</p>
            <p><strong>📈 Y-Axis:</strong> {chart.yAxis}</p>
            <p><strong>🔍 What’s Inside:</strong> {chart.content}</p>
            <p><strong>💡 Extras:</strong> {chart.extra}</p>
          </div>
        ))}
      </div>

      <div className="mt-12">
        <h3 className="text-2xl font-bold text-yellow-200 mb-4">🛣️ In Our Roadmap </h3>
        <ul className="list-disc pl-6 space-y-2">
          {roadmap.map((item, idx) => (
            <li key={idx} className="text-white">{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

// Helper function to convert milliseconds to 'minutes:seconds'
const millisecondsToTime = (milliseconds) => {
  const minutes = Math.floor(milliseconds / 60000);
  const seconds = Math.floor((milliseconds % 60000) / 1000);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

// Helper function to format date to 'dd-mm-yyyy'
const formatDate = (dateStr) => {
  const [year, month, day] = dateStr.split('T')[0].split('-');
  return `${day}-${month}-${year}`;
};

// Helper function to aggregate data
const aggregateData = (data) => {
  const aggregatedData = Object.entries(data).reduce((acc, [date, entries]) => {
    if (!acc[date]) {
      acc[date] = { pageCount: 0, timeSpent: 0 };
    }

    entries.forEach(entry => {
      acc[date].pageCount += entry.pageNumber || 0;
      acc[date].timeSpent += entry.readTimeInMiliseconds || 0;
    });

    return acc;
  }, {});

  // Convert aggregated data to array format and sort by date descending
  return Object.entries(aggregatedData)
    .map(([date, { pageCount, timeSpent }]) => ({
      dateRead: formatDate(date),
      pageCount,
      timeSpent: millisecondsToTime(timeSpent)
    }))
    .sort((a, b) => {
      const [dayA, monthA, yearA] = a.dateRead.split('-').map(Number);
      const [dayB, monthB, yearB] = b.dateRead.split('-').map(Number);
      return new Date(yearB, monthB - 1, dayB) - new Date(yearA, monthA - 1, dayA);
    });
};


// Main Component
function BookReadTimeLineCharts() {
  const [selectedChart, setSelectedChart] = useState('Bar');
  const location = useLocation();
  const [data, setData] = useState([]);
  const [rawData, setRawData] = useState([]);
  useEffect(() => {
    if (location?.state?.graphData) {
      setRawData(location.state.graphData);
    }
  }, [location?.state?.graphData]);
  const [barPieChartData, setBarPieChartData] = useState([]);
  const [lineChartData, setLineChartData] = useState([]);
  const [heatMapChartData, setHeatMapChartData] = useState([]);
  const [violinChartData, setViolinChartData] = useState([]);
  const [scatterPlotChartData, setScatterPlotChartData] = useState([]);
  const [radarChartData, setRadarChartData] = useState([]);
  const [boxPlotChartData, setBoxPlotChartData] = useState([]);
  const [areaChartData, setAreaChartData] = useState([]);

  const [readerName, setReaderName] = useState("");
  useEffect(() => {
    if (location.state && location.state.graphData && typeof location.state.graphData === 'object') {
      const formattedData = aggregateData(location.state.graphData); 
      // console.log("location data: ",location.state.selectedReader);
      setReaderName(location?.state?.selectedReader || "");
      const transformedDataForLineChart = transformGraphDataForLineChart(location.state.graphData); 
      const groupedData = groupByTimeSlotAndInterval(location.state.graphData); 
      // console.log("Raw Data: ", location.state.graphData); 
      // console.log("Transformed Data for Scatter Plot: ", groupedData); 
      // setRawData(location.state.graphData || []);
      setBarPieChartData(formattedData); 
      setLineChartData(transformedDataForLineChart); 
      setScatterPlotChartData(groupedData);
      setHeatMapChartData(location.state.graphData);
      setViolinChartData(buildViolinChartData(location.state.graphData));
      setRadarChartData(buildRadarChartData(location.state.graphData));
      setBoxPlotChartData(buildWeekdaySummaryData(location.state.graphData));
      // setAreaChartData(buildAreaChartData(location.state.graphData));
      setAreaChartData(buildTimeOfDayByWeekdayData(location.state.graphData));   
    } else {
      setData(fallbackData);
    }
  }, [location.state]);

  const handleChartChange = useCallback((chartType) => {
    setSelectedChart(chartType);
  }, []);

  const renderChart = () => {
    switch (selectedChart) {
      case 'Bar':
        return <ReadLogBarChart data={barPieChartData} title="Read Time Bar Chart" />;
      case 'Line':
        return <ReadLogLineChart data={lineChartData} title="Read Time Line Chart" />;
      case 'Pie':
        return <ReadLogPieChart data={barPieChartData} title="Read Time Pie Chart" />;
      case 'Scatter':
        return <ReadLogScatterPlot data={scatterPlotChartData} title="Read Time Scatter Plot Chart" />;
      case 'Heatmap':
        return <ReadLogHeatmap data={heatMapChartData} title="Habit hotspots" />;
      case 'Violin':
        return <ReadLogViolinChart data={violinChartData} title="Frequency insights" />;
      case 'Radar':
        return <ReadLogRadarChart data={radarChartData} title="Radar Chart" />;        
      case 'Boxplot':
        return <ReadLogBoxPlotChart data={boxPlotChartData} title="Median, spread, outliers" />;
      case 'Area':
        return <ReadLogAreaChart data={areaChartData} title="Reading Patterns by Time of Day" />;        
      // case 'Area':
      //   return <ReadLogTimeOfDayChart data={areaChartData} title="Reading Patterns by Time of Day" />;
      // case 'Area':
      //    return <ReadLogAreaChart data={areaChartData} title="Group growth + individual impact" />;
      case 'Help':
          return <ReadLogBigDataHelp title="About Reading Log Big Data" />;  
      default:
        return <div className='text-yellow-200'>Select a chart to display</div>;
    }
  };

  return (
    <div className='bg-black'>
      <div className="flex justify-start mb-2 border-b border-blue-400">
          <h2 className="text-xl lg:text-2xl font-bold text-yellow-200 text-center mb-4 py-2 px-4">Book Reading Engagement </h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 justify-center mb-2 px-4">
        <button onClick={() => handleChartChange('Bar')} className="bg-blue-600 text-white text-xs lg:text-m p-2">Bar Graph</button>
        <button onClick={() => handleChartChange('Line')} className="bg-blue-600 text-white text-xs lg:text-m p=2">Line Chart</button>
        <button onClick={() => handleChartChange('Pie')} className="bg-blue-600 text-white text-xs lg:text-m p-2">Pie Chart</button>
        <button onClick={() => handleChartChange('Scatter')} className="bg-blue-600 text-white text-xs lg:text-m p-2">Scatter Chart</button>
        <button onClick={() => handleChartChange('Heatmap')} className="bg-blue-600 text-white text-xs lg:text-m p-2">Heatmap</button>
        <button onClick={() => handleChartChange('Radar')} className="bg-blue-600 text-white text-xs lg:text-m p-2">Radar Chart</button>
        <button onClick={() => handleChartChange('Violin')} className="bg-blue-600 text-white text-xs lg:text-m p-2">Violin Chart</button>
        <button onClick={() => handleChartChange('Boxplot')} className="bg-blue-600 text-white text-xs lg:text-m p-2">BoxPlot Chart</button>
        <button onClick={() => handleChartChange('Area')} className="bg-blue-600 text-white text-xs lg:text-m p-2">Stacked Area Chart</button>
        <button onClick={() => handleChartChange('Help')} className="bg-blue-600 text-white text-xs lg:text-m p-2">Help</button>
      </div>
      <div className='flex justify-center'><p>{readerName}</p></div>
      <div className="chart-container min-h-[500px]">
        {renderChart()}
      </div>
    <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
}

export default BookReadTimeLineCharts;
